import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

type DimensionSelectProps = {
  options: {
    value: string;
    name: string;
  }[];
  onChange: (value: string) => void;
};

export const DimensionSelect = (props: DimensionSelectProps) => {
  return (
    <FormControl>
      <InputLabel id="dimension-select-label">Dimension</InputLabel>
      <Select
        fullWidth
        labelId="dimension-select-label"
        defaultValue={props.options[0]?.value}
        onChange={e => props.onChange(e.target.value)}
        size="small"
        label="Dimension"
      >
        {props.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
